const actions = {
  methods: {
    toggle_ ({ catalog, id }) {
      this.$store.dispatch('saveMixed', { page: 4, type: 2, data: { catalog, id }, ignoreResponseBar: false })
    },
    delete_ ({ catalog, id, title }) {
      this.$store.dispatch('setOverlay', true)
      this.$root.$dialog.confirm({
        text: `${this.lang.additional.dialog.deleteConfirm} ${title}?`,
        title: this.lang.confirm.title,
        waitForResult: true
      }).then(res => {
        this.$store.dispatch('setOverlay', false)
        if (res) this.$store.dispatch('saveMixed', { page: 4, type: 1, data: { catalog, id }, ignoreResponseBar: false })
      })
    }
  }
}
export default actions
